import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { buildJsonLd } from "@/lib/schema";

export default function SchemaMarkup() {
  const { pathname } = useLocation();

  useEffect(() => {
    document
      .querySelectorAll('script[data-seo-schema="true"]')
      .forEach((el) => el.remove());

    const schemas = buildJsonLd(pathname);
    schemas.forEach((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-schema", "true");
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document
        .querySelectorAll('script[data-seo-schema="true"]')
        .forEach((el) => el.remove());
    };
  }, [pathname]);

  return null;
}